module.exports = __webpack_public_path__ + "static/img/1-2.bbe4828.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/1-2.png
// module id = 5oGX
// module chunks = 0